import { Button } from '@wheely/ui-kit';
import React from 'react';
import { Control } from 'react-hook-form';
import { FormattedMessage, useIntl } from 'react-intl';

import { TUpdateCarLicensingForm } from '@/modules/car/actions/async/updateCarLicensing';
import { BottomButtons } from '@/shared/view/BottomButtons';
import { LicensingAuthorityField, PHVField } from '@/shared/view/LicensingFields';
import { StepLayout } from '@/shared/view/StepLayout';

import s from './styles.module.css';

type IEditVehicleLicensingViewProps = {
  control: Control<TUpdateCarLicensingForm>;
  isSubmitting?: boolean;
  onSubmit: (e?: React.BaseSyntheticEvent) => void;
  onNavigateBack: () => void;
};

const EditVehicleLicensingView = ({
  onSubmit,
  control,
  isSubmitting,
  onNavigateBack,
}: IEditVehicleLicensingViewProps) => {
  const intl = useIntl();

  return (
    <StepLayout
      hideProgress={true}
      title={intl.formatMessage({
        defaultMessage: 'Vehicle info',
        id: 'c0G8wG',
        description: 'Vehicle info (onboarding step title)',
      })}
      onClickBack={onNavigateBack}
    >
      <main className={s.wrapper}>
        <form onSubmit={onSubmit} className={s.form}>
          <div>
            <LicensingAuthorityField control={control} />
            <PHVField control={control} />
          </div>

          <BottomButtons>
            <Button type="submit" disabled={isSubmitting} className={s.mainButton}>
              <FormattedMessage defaultMessage="Save" id="RT8KNi" description="Save button text" />
            </Button>
          </BottomButtons>
        </form>
      </main>
    </StepLayout>
  );
};

export type { IEditVehicleLicensingViewProps };
export { EditVehicleLicensingView };
